import { render, staticRenderFns } from "./DancerEvents.vue?vue&type=template&id=c1df84e8&scoped=true&"
import script from "./DancerEvents.vue?vue&type=script&lang=js&"
export * from "./DancerEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1df84e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1df84e8')) {
      api.createRecord('c1df84e8', component.options)
    } else {
      api.reload('c1df84e8', component.options)
    }
    module.hot.accept("./DancerEvents.vue?vue&type=template&id=c1df84e8&scoped=true&", function () {
      api.rerender('c1df84e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/components/DancerEvents.vue"
export default component.exports